import { CUSTOMERS_PROFILES_COLUMN_NAME, ICustomersProfilesFilters } from '../types';
import { SORTING_DIRECTION } from 'src/constants/main';

export const defaultCustomersProfilesFilters: ICustomersProfilesFilters = {
  search: '',
  status: undefined,
  sortDir: SORTING_DIRECTION.ASCENDING,
  sortField: CUSTOMERS_PROFILES_COLUMN_NAME.NAME,
};
